
import React, { useState } from 'react';

import { getToken, utc_local, get_order_status_color,payment_status_color, amountFormat } from '../../helpers/Helper';
import { post } from '../../helpers/api_helper';
import { POST_ORDER_LIST, POST_UPDATE_ORDER_STATUS } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';
import useMounted from '../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";
import { useNavigate } from 'react-router-dom';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Orders = (props) => {
    const navigate = useNavigate();

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ orderId: 0, orderStatus: '', noteType : 'internal' });
    const [filter_option, setFilterOption] = useState({status: '', startDate : '', endDate : ''});


    useMounted(() => {
        get_order_list()
    })

    const get_order_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [6,7,8,9] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.orderStatus = filter_option.status;
                    data.startDate = (filter_option.startDate)? new Date(filter_option.startDate).getTime() : '';
                    data.endDate = (filter_option.endDate)? new Date(filter_option.endDate).getTime() : '';

                    $.ajax({
                        "url": POST_ORDER_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "success": callback,
                        "error": function (xhr, textStatus, errorThrown) {
                            if (xhr.status === 401) {
                                window.location.href = '/logout';
                            }
                        }
                    });
                },
                "columns": [
                    { "data": "orderId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {utc_local(data.createdAt,'DD MMM YYYY')}
                            </>, td)
                        }
                    },
                    { "data": "name" },
                    { "data": "phoneNo" },
                    { "data": "email" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {amountFormat(data.grandTotal)}
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <span className={`badge text-capitalize ${get_order_status_color(data.orderStatus)}`}>{data.orderStatus}</span>
                            </>, td)
                        }
                    },
                    { "data": "paymentMethod" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <span className={`badge text-capitalize ${payment_status_color(data.paymentStatus)}`}>{data.paymentStatus}</span>
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <button className="btn btn-sm text-info"  onClick={() => { navigate('/orders/view/' + data.orderId); }}><i className="bx bx-show align-middle"></i></button>
                            </>, td)
                        }
                    },
                ]
            });
        }
    }


    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        SetButtonDisabled(true);
        var res_data = await post(POST_UPDATE_ORDER_STATUS, form_inputs);
        if (res_data.status) {
            toast(res_data.message);
            $('.modal-close').click();
            get_order_list();
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

     // input text change handler
    const handleInputChangeFilter = (event) => {
        console.log(event);
        if(event.target.name === 'status'){
        }else{
            
        }
        setFilterOption(inputs => ({ ...filter_option, [event.target.name]: event.target.value }));
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Orders</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />
                            <div className='row mt-4 mb-3'>
                                <div className='col-sm-3 mb-2'>
                                    <DatePicker name='startDate' className='form-control' 
                                    selected={filter_option.startDate} onChange={(date) => {handleInputChangeFilter({target : {name : 'startDate', value : date}})}} 
                                    placeholderText="Start Date"
                                    dateFormat="dd/MM/YYYY"
                                    maxDate={filter_option.endDate}
                                    onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-2'>
                                    <DatePicker name='endDate' className='form-control' 
                                    selected={filter_option.endDate} onChange={(date) => {handleInputChangeFilter({target : {name : 'endDate', value : date}})}}
                                    placeholderText="End Date"
                                    dateFormat="dd/MM/YYYY"
                                    minDate={filter_option.startDate}
                                    onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-2'>
                                    <select name='status' className='form-control' value={filter_option.status} onChange={handleInputChangeFilter}>
                                        <option value="">All</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Order Placed">Order Placed</option>
                                        <option value="Order Confirmed">Order Confirmed</option>
                                        <option value="On Hold">On Hold</option>
                                        <option value="In Review">In Review</option>
                                        <option value="Packed">Packed</option>
                                        <option value="Shipped">Shipped</option>
                                        <option value="Out for Delivery">Out for Delivery</option>
                                        <option value="Delivered">Delivered</option>
                                        <option value="Cancelled">Cancelled</option>
                                        <option value="Returned">Returned</option>
                                        <option value="Refunded">Refunded</option>
                                    </select>
                                </div>
                                <div className='col-sm-3 mb-2'>
                                    <button type='button' onClick={get_order_list} className='btn btn-primary'>Apply</button>
                                </div>
                            </div>
                            <div className='table-responsive text-nowrap'>
                                    <table id="dataTableExample" className="table table-striped">
                                        <thead>
                                            <tr>
                                                <td>Order No</td>
                                                <td>Order Date</td>
                                                <td>Name</td>
                                                <td>Phone Number</td>
                                                <td>Email</td>
                                                <td>Order Amount</td>
                                                <td>Order Status</td>
                                                <td>Payment Method</td>
                                                <td>Payment Status</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                    </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="EditModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Update Order Status</h5>
                            <button type="button" className="btn btn-sm close modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <hr className='mb-0' />
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <form className="av-invalid" onSubmit={handleSubmit}>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize">Select Order Status *</label>
                                            <select name='orderStatus' value={form_inputs.orderStatus} onChange={handleInputChange} className="form-control" >
                                                <option value="pending">Pending</option>
                                                <option value="processing">Processing</option>
                                                <option value="in-process">In Process</option>
                                                <option value="in-review">In Review</option>
                                                <option value="on-hold">On-Hold</option>
                                                <option value="completed">Completed</option>
                                                <option value="cancelled">Cancelled</option>
                                                <option value="refunded">Refunded</option>
                                                <option value="failed">Failed</option>
                                            </select>
                                        </div>
                                        <div className='mb-3'>
                                            <label>Note Type</label>
                                            <select name='noteType' value={form_inputs.noteType} onChange={handleInputChange} className="form-control" >
                                                <option value="customer">Customer</option>
                                                <option value="internal">Internal</option>
                                            </select>
                                        </div>
                                        <div className='text-center pt-4'>
                                            <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2"> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Update </button>
                                            <button type='button' data-bs-dismiss="modal" aria-label="Close" className="btn btn-danger ms-3"> Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Orders;